import type { FirestoreSource, SourceDisplayMode, SourceType } from '../firestore';
import { BaseRow } from './row';

export class BaseSource {
  id: string;
  sessionId: string;
  data: FirestoreSource;
  rows: Record<string, BaseRow> = {};

  constructor(id: string, sessionId: string, data: FirestoreSource) {
    this.id = id;
    this.sessionId = sessionId;
    this.data = data;
  }

  get type(): SourceType {
    return this.data.type || 'text';
  }

  /**
   * How this source should be displayed.
   * - 'spreadsheet': compact rows (44px), text-oriented columns
   * - 'gallery': tall rows (180px), image column visible
   *
   * Defaults based on source type for backward compat:
   * image sources → gallery, text sources → spreadsheet.
   */
  get displayMode(): SourceDisplayMode {
    if (this.data.displayMode) return this.data.displayMode;
    return this.data.type === 'image' ? 'gallery' : 'spreadsheet';
  }

  get defaultFieldIds(): string[] {
    if (this.data.defaultFields && this.data.defaultFields.length > 0) {
      return this.data.defaultFields;
    }

    return this.data.fieldIds;
  }

  /** Convenience: true when displayMode is 'gallery'. Use instead of type === 'image'. */
  get isGalleryView(): boolean {
    return this.displayMode === 'gallery';
  }

  /** True if the source has image-type columns (fieldImages). */
  get hasImageFields(): boolean {
    return (this.data.imageFieldIds?.length ?? 0) > 0;
  }
}
